import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

interface AiSearchResponse {
  data: any
  resources: any
}

export const AiApi = createApi({
  reducerPath: 'aiApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
  }),
  endpoints: (build) => ({
    getAiSearch: build.query<
      AiSearchResponse,
      { tourId: string; locId: string; search: string }
    >({
      query: ({ tourId, locId, search }) => ({
        url: `experience/${locId}/tour/${tourId}/ai-search/media`,
        params: { q: search, size: 10, page: 0, module_id: 'walkingtour' },
      }),
    }),
  }),
})

export const { useGetAiSearchQuery } = AiApi
